import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  watch,
  nextTick,
  onMounted,
  defineProps,
  defineEmits,
} from "../TUIKit/adapter-vue";
import TUIChatEngine, {
  TUITranslateService,
  TUIUserService,
  TUIStore,
  StoreName,
  TUIChatService,
} from "@tencentcloud/chat-uikit-engine";
import { TUILogin } from "@tencentcloud/tui-core";
import { Toast, TOAST_TYPE } from "../TUIKit/components/common/Toast/index";
import BottomPopup from "../TUIKit/components/common/BottomPopup/index.vue";
import Icon from "../TUIKit/components/common/Icon.vue";
import AboutDialog from "../components/About.vue";
import EditProfileDialog from "../components/EditProfile.vue";
import rightArrowIcon from "../TUIKit/assets/icon/right-icon.svg";
import selectedIcon from "../TUIKit/assets/icon/selected.svg";
import { IUserProfile } from "../TUIKit/interface";
import { isPC } from "../TUIKit/utils/env";
import router from "../router/index";
import { deepCopy } from "../TUIKit/components/TUIChat/utils/utils";
import { translator } from "../TUIKit/components/TUIChat/utils/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  props: {
  displayType: {
    type: String,
    default: "profile", // "profile"/"setting"/"all"
  },
  showSetting: {
    type: Boolean,
    default: false,
  },
},
  emits: ["toggleSettingShow"],
  setup(__props, { emit: emits }) {

const props = __props



const settingDomRef = ref();
const userProfile = ref<IUserProfile>({});
const isAboutBoxShow = ref<boolean>(false);
const isEditProfileBoxShow = ref<boolean>(false);
const hideSetting = ref<boolean>(false);
const settingList = ref<{
  [propsName: string]: {
    value: string;
    label: string;
    onClick?: any;
    // children related
    selectedChild?: string;
    childrenShowType?: string; // "bottomPopup"/"switch"
    showChildren?: boolean;
    children?: {
      [propsName: string]: {
        value: string;
        label: string;
        onClick?: any;
      };
    };
  };
}>({
  editProfile: {
    value: "editProfile",
    label: "编辑资料",
    onClick: () => {
      hideSetting.value = true;
      isEditProfileBoxShow.value = true;
    },
    hidden: true,
  },
  allowType: {
    value: "allowType",
    label: "加我为好友时",
    selectedChild: "",
    childrenShowType: "bottomPopup",
    showChildren: false,
    hidden: true,
    onClick: (item: any) => {
      if (!isPC) {
        item.showChildren = true;
      }
    },
    children: {
      [TUIChatEngine.TYPES.ALLOW_TYPE_ALLOW_ANY]: {
        value: TUIChatEngine.TYPES.ALLOW_TYPE_ALLOW_ANY,
        label: "同意任何用户加好友",
        onClick: (item: any) => {
          switchAllowType(item.value);
        },
      },
      [TUIChatEngine.TYPES.ALLOW_TYPE_NEED_CONFIRM]: {
        value: TUIChatEngine.TYPES.ALLOW_TYPE_NEED_CONFIRM,
        label: "需要验证",
        onClick: (item: any) => {
          switchAllowType(item.value);
        },
      },
      [TUIChatEngine.TYPES.ALLOW_TYPE_DENY_ANY]: {
        value: TUIChatEngine.TYPES.ALLOW_TYPE_DENY_ANY,
        label: "拒绝任何人加好友",
        onClick: (item: any) => {
          switchAllowType(item.value);
        },
      },
    },
  },
  displayMessageReadReceipt: {
    value: "displayMessageReadReceipt",
    label: "消息阅读状态",
    selectedChild: "userLevelReadReceiptOpen",
    childrenShowType: "bottomPopup",
    showChildren: false,
    onClick(item: any) {
      if (!isPC) {
        item.showChildren = true;
      }
    },
    children: {
      userLevelReadReceiptOpen: {
        value: "userLevelReadReceiptOpen",
        label: "开启",
        onClick() {
          switchEnableUserLevelReadReceipt(true);
        },
      },
      userLevelReadReceiptClose: {
        value: "userLevelReadReceiptClose",
        label: "关闭",
        onClick() {
          switchEnableUserLevelReadReceipt(false);
        },
      },
    },
  },
  displayOnlineStatus: {
    value: "displayOnlineStatus",
    label: "显示在线状态",
    selectedChild: "userLevelOnlineStatusOpen",
    childrenShowType: "bottomPopup",
    showChildren: false,
    onClick(item: any) {
      if (!isPC) {
        item.showChildren = true;
      }
    },
    children: {
      userLevelOnlineStatusOpen: {
        value: "userLevelOnlineStatusOpen",
        label: "开启",
        onClick() {
          switchUserLevelOnlineStatus(true);
        },
      },
      userLevelOnlineStatusClose: {
        value: "userLevelOnlineStatusClose",
        label: "关闭",
        onClick() {
          switchUserLevelOnlineStatus(false);
        },
      },
    },
  },
  translateLanguage: {
    value: "translateLanguage",
    label: "翻译语言",
    selectedChild: "zh",
    childrenShowType: "bottomPopup",
    showChildren: false,
    onClick(item: any) {
      if (!isPC) {
        item.showChildren = true;
      }
    },
    children: {
      zh: {
        value: "zh",
        label: "zh",
        onClick() {
          switchTranslationTargetLanguage("zh");
        },
      },
      en: {
        value: "en",
        label: "en",
        onClick() {
          switchTranslationTargetLanguage("en");
        },
      },
      jp: {
        value: "jp",
        label: "jp",
        onClick() {
          switchTranslationTargetLanguage("jp");
        },
      },
      kr: {
        value: "kr",
        label: "kr",
        onClick() {
          switchTranslationTargetLanguage("kr");
        },
      },
    },
  },
  // about: {
  //   value: "about",
  //   label: "关于腾讯云IM",
  //   selectedChild: "",
  //   childrenShowType: "bottomPopup",
  //   showChildren: false,
  //   children: {},
  //   onClick: () => {
  //     hideSetting.value = true;
  //     isAboutBoxShow.value = true;
  //   },
  // },
  // exit: {
  //   value: "exit",
  //   label: "退出登录",
  //   onClick: () => {
  //     TUILogin.logout().then(() => {
  //       router.push({ path: "/" });
  //     });
  //   },
  // },
});

const handleSettingListItemOnClick = (item: any) => {
  if (item?.onClick && typeof item?.onClick === "function") {
    item.onClick(item);
  }
};

const closeAboutBox = () => {
  isAboutBoxShow.value = false;
  emits("toggleSettingShow", false);
};

const closeEditProfileBox = () => {
  isEditProfileBoxShow.value = false;
  emits("toggleSettingShow", false);
};

const updateMyProfile = (props: object) => {
  TUIUserService.updateMyProfile(props)
    .then(() => {
      Toast({
        message: "更新用户资料成功",
        type: TOAST_TYPE.SUCCESS,
      });
    })
    .catch((err: any) => {
      console.warn("更新用户资料失败", err);
      Toast({
        message: "更新用户资料失败",
        type: TOAST_TYPE.ERROR,
      });
    });
};

TUIStore.watch(StoreName.USER, {
  userProfile: (userProfileData: IUserProfile) => {
    userProfile.value = deepCopy(userProfileData);
    if (userProfile?.value?.allowType) {
      settingList.value.allowType.selectedChild = userProfile?.value?.allowType;
    }
  },
  displayMessageReadReceipt(isDisplay: boolean) {
    settingList.value.displayMessageReadReceipt.selectedChild = isDisplay
      ? "userLevelReadReceiptOpen"
      : "userLevelReadReceiptClose";
  },
  displayOnlineStatus(isOnlineStatusDisplay: boolean) {
    settingList.value.displayOnlineStatus.selectedChild = isOnlineStatusDisplay
      ? "userLevelOnlineStatusOpen"
      : "userLevelOnlineStatusClose";
  },
});

// pc click outside
let clickOutside = false;
let clickInner = false;
const onClickOutside = (component: any) => {
  document.addEventListener("mousedown", onClickDocument);
  component?.addEventListener &&
    component?.addEventListener("mousedown", onClickTarget);
};
const onClickDocument = () => {
  clickOutside = true;
  if (!clickInner && clickOutside) {
    emits("toggleSettingShow", false);
    removeClickListener(settingDomRef.value);
  }
  clickOutside = false;
  clickInner = false;
};
const onClickTarget = () => {
  clickInner = true;
};
const removeClickListener = (component: any) => {
  document.removeEventListener("mousedown", onClickDocument);
  component?.removeEventListener &&
    component?.removeEventListener("mousedown", onClickTarget);
};

watch(
  () => props.showSetting,
  (newVal: any, oldVal: any) => {
    if (isPC && newVal && !oldVal) {
      nextTick(() => {
        onClickOutside(settingDomRef.value);
      });
    }
  },
  {
    immediate: true,
  }
);

onMounted(() => {
  // get user profile
  TUIUserService.getUserProfile().then((res: any) => {
    userProfile.value = res.data;
  });
  // get current target language when component mounted
  const lang = TUIStore.getData(StoreName.USER, "targetLanguage");
  if (lang) {
    settingList.value.translateLanguage.selectedChild = lang;
  }
});

function switchAllowType(value: string) {
  updateMyProfile({ allowType: value });
  settingList.value.allowType.showChildren = false;
}

function switchEnableUserLevelReadReceipt(status: boolean) {
  TUIStore.update(StoreName.USER, "displayMessageReadReceipt", status);
  settingList.value.displayMessageReadReceipt.showChildren = false;
}

function switchUserLevelOnlineStatus(status: boolean) {
  TUIUserService.switchUserStatus({ displayOnlineStatus: status });
  settingList.value.displayOnlineStatus.showChildren = false;
}

function switchTranslationTargetLanguage(lang: string) {
  translator.clear();
  TUIChatService.setTranslationLanguage(lang);
  settingList.value.translateLanguage.selectedChild = lang;
  settingList.value.translateLanguage.showChildren = false;
}

return { __sfc: true,props, emits, settingDomRef, userProfile, isAboutBoxShow, isEditProfileBoxShow, hideSetting, settingList, handleSettingListItemOnClick, closeAboutBox, closeEditProfileBox, updateMyProfile, clickOutside, clickInner, onClickOutside, onClickDocument, onClickTarget, removeClickListener, switchAllowType, switchEnableUserLevelReadReceipt, switchUserLevelOnlineStatus, switchTranslationTargetLanguage, TUITranslateService, BottomPopup, Icon, AboutDialog, EditProfileDialog, rightArrowIcon, selectedIcon, isPC }
}

})